<template>
    <div>
        <!-- кнопки управления -->
        <div  class='row no-wrap justify-end q-mr-lg q-mt-md q-mb-lg desktop-only' >
            <q-btn label='Распечатать' @click='printReport' icon='print' color='positive'/>
        </div>
        <!-- фильтры таблицы -->
        <div class='q-title text-primary'>Заказы, где ничего не сделано, чтобы получить деньги</div>
        <div class='row no-wrap bg-white text-center text-white q-body-1 shadow-1'>
            <div class='col-1 q-pa-sm'>№ заказа</div>
            <div class='col-2 q-pa-sm'>
                <q-select v-model='contragentFilter' :options='contragentList' filter separator clearable/>
            </div>
            <div class='col-2 q-pa-sm'>
                <q-select v-model='executorFilter' :options='executorList' filter separator clearable/>                
            </div>
            <div class='col-3 q-pa-sm'>
                <q-select v-model='managerFilter' :options='usersList' filter separator clearable/>                
            </div>
            <div class='col-2 q-pa-sm'></div>
            <div class='col-2 q-pa-sm'></div>
        </div>        
        <!-- заголовок таблицы -->
        <div id='print-container'>
            <div class='row no-wrap bg-primary text-center text-white q-body-1 shadow-1'>
                <div class='col-1 q-pa-sm'>№ заказа</div>
                <div class='col-2 q-pa-sm'>Контрагент</div>
                <div class='col-2 q-pa-sm'>Исполнитель</div>
                <div class='col-3 q-pa-sm'>Менеджер</div>
                <div class='col-2 q-pa-sm'>Сумма заказа</div>
                <div class='col-1 q-pa-sm'>Оплачено</div>
                <div class='col-1 q-pa-sm'>Долг</div>
            </div>
            <!-- Заказы без счета -->
            <div v-for='(order) in noOneDebitOrders' :key = '"debitOrder2"+order.id' class='q-body-1 q-pa-xs row no-wrap bg-grey-2 shadow-1 myLine q-pt-xs q-pb-xs' style='margin-bottom: 1px; border-bottom: 1px solid lightgray'>
                <noOneDebitLine 
                    :order = order
                />
            </div>
<!-- Заказы со счетом счетом -->
       <!-- заголовок таблицы -->
            <div class='q-title text-primary q-mt-lg q-mb-lg'>Выставлен счет</div>

            <div class='row no-wrap bg-white text-center text-white q-body-1 shadow-1'>
                <div class='col-1 q-pa-sm'>№ заказа</div>
                <div class='col-2 q-pa-sm'>
                    <q-select v-model='contragentFilter' :options='contragentList' filter separator clearable/>
                </div>
                <div class='col-2 q-pa-sm'>
                    <q-select v-model='executorFilter' :options='executorList' filter separator clearable/>                
                </div>
                <div class='col-3 q-pa-sm'>
                    <q-select v-model='managerFilter' :options='usersList' filter separator clearable/>                
                </div>
                <div class='col-2 q-pa-sm'></div>
                <div class='col-2 q-pa-sm'></div>
            </div>        


            <div class='row no-wrap bg-primary text-center text-white q-body-1 shadow-1 items-center'>
                <div class='col-1 q-pa-sm'>№ заказа</div>
                <div class='col-2 q-pa-sm'>Контрагент</div>
                <div class='col-2 q-pa-sm'>Исполнитель</div>
                <div class='col-2 q-pa-sm'>Менеджер</div>
                <div class='col-1 q-pa-sm'>Сумма заказа</div>
                <div class='col-1 q-pa-sm'>Оплачено</div>
                <div class='col-1 q-pa-sm'>Долг</div>
                <div class='col-2 q-pa-sm'>Счет</div>
            </div>
       
            <div v-for='(order, key) in billExistDebitOrders' :key = '"debitOrder"+key' class='q-body-1 q-pa-sm row no-wrap bg-grey-2 shadow-1 myLine' style='margin-bottom: 1px; border-bottom: 1px solid lightgray'>
                <billDebitLine
                    :order = order
                />
            </div>
        </div>
    </div>
</template>
<script>
/* eslint-disable */
export default {
    name : 'debit',

    data() {
        return {
            contragentFilter : null,
            executorFilter : null,
            managerFilter : null,
            contragents : [],
            executors : [],
        }
    },
    components : {
        noOneDebitLine : () => import('./noOneLine.vue'),
        billDebitLine : () =>import('./billDebitLine.vue')
    },

    created() {
        let q = this.$store.getters.allContragents;
        if ((q==null)||(q.length == 0)) {
            this.$store.dispatch('retrieveContragents');
        }

        q = this.$store.getters.getAllExecutors;
        if ((q==null)||(q.length == 0)) {
            this.$store.dispatch('getAllExecutors');
        }

        q = this.$store.getters.allUsers;
        if ((q==null)||(q.length == 0)) {
            this.$store.dispatch('retrieveUsers');
        }

        q = this.$store.getters.getAllOrganization;
        if ((q==null)||(q.length == 0)) {
            this.$store.dispatch('getOrganization');
        }

        this.$store.dispatch('getDebitOrders');

    },


    computed : {
        usersList() {
            let q = this.$store.getters.allUsers;
            let result = [];
            q.forEach(e => {
                result.push({
                    value : e.id,
                    label : e.name + ' '+e.surname,
                });
            });
            return result;
        },

        contragentList() {
           return this.contragents;
        }, 
        executorList() {
            return this.executors;
        },
        noOneDebitOrders () {
            let q = this.allDebitOrders;
           
            return q.filter(item => {
                // console.log(item);
               return item.bill_out == null;
            });
        },

        billExistDebitOrders() {
            let q = this.allDebitOrders;
            return q.filter(item => {
                // console.log(item);
               return item.bill_out != null;
            });
        },  

        allDebitOrders() {
            let oldId = -1;
            let orders = this.$store.getters.allDebitOrders;
            
            let result = [];
            let prom = null;
            let orderFile = [];
            let orderCost = 0;
            orders.forEach(order => {
                if (order.main_id != oldId) { // новый ордер
                    // здесь нужно вставлять накопленный ордер
                    if (prom != null) {
                        result.push(prom);// добавляем                        
                    }
                    // проверяем на список контрагентов
                    let index = this.contragents.findIndex(item=>{
                        return item.value == order.contragent;
                    });
                    if (index < 0) { // добавляем в список контрагентов для фильтра нового
                        let c = this.$store.getters.getContragentById(order.contragent);
                        this.contragents.push({
                            value : c.id,
                            label : c.name
                        })
                    }
                    //проверяем списко исполнителей
                    index = this.executors.findIndex(item => {
                        return item.value == order.executor;
                    });
                    if (index < 0) { // добавляем в список контрагентов для фильтра нового
                        let c = this.$store.getters.getExecuterById(order.executor);
                        if (c != null)
                            this.executors.push({
                                value : c.id,
                                label : c.name
                            })
                    }
                    

                    oldId = order.main_id;
                    prom = new Object();
                    prom.manager = order.manager;
                    prom.contragent = order.contragent;
                    prom.id = order.main_id;
                    prom.bill_out = order.bill_out;
                    prom.executor = order.executor;
                    prom.pay_info = JSON.parse(order.pay_info); 
                    let s = 0; 
                    if (prom.pay_info != null) {
                        s = prom.pay_info['Наличные']*1 + prom.pay_info['Безналичные']*1
                    }
                    prom.pay_summ = s;
                    prom.files = []; // добавляем файлики
                    prom.orderCost = 0;
                }
                prom.orderCost += order.cost*1;
                prom.debit = prom.orderCost*1 - prom.pay_summ*1;
                prom.files.push(order);
            });

            return result.filter(item => {
                let isOk = true;
                isOk = this.contragentFilter != null ? (isOk)&&(item.contragent == this.contragentFilter) : isOk;
                isOk = this.executorFilter != null ? (isOk) && (item.executor == this.executorFilter) : isOk;
                isOk = this.managerFilter != null ? (isOk)&&(item.manager == this.managerFilter) : isOk;
                return isOk;
            });
        }
    },
    methods : {

        getDebitBill(bill_out) {
            let result = {};
            let b = this.$store.getters.getDebitBillById(bill_out);
            if (b.number == null) {
                result.number = '-';
                result.org = '';
            } else 
            {
                let org = this.$store.getters.getOrganizationById(b.org);
                result.number = 'счет № '+b.number;
                result.org = org != null ? org.name : '';
            }
            return (result);
        },

        
        printReport() {
            this.$htmlToPaper('print-container');
        },

        getManager(id) {
            let q = this.$store.getters.getUserById(id);
            return q != null ? q.name+' ' + q.surname : '-';
        },

        getContragent(id) {
            let q = this.$store.getters.getContragentById(id);
            return q != null ? q.name : "-";
        },

        getExecutor(id) {
            let q = this.$store.getters.getExecuterById(id);
            return q != null ? q.name : '-';
        }

    }
}
</script>
<style lang="scss" scoped>
    .myLine {
        cursor : pointer;
        &:hover{
            background: rgb(182, 255, 182) !important;
        }
    }
</style>
